import { Directive, inject, TemplateRef, ViewContainerRef, effect, Injector } from '@angular/core';
import { AuthenticationService } from "@core/services/authentication.service";

@Directive({
  selector: '[isLoggedIn]',
  standalone: true,
})
export class IsLoggedInDirective {
  #templateRef = inject(TemplateRef<unknown>);
  #viewContainer = inject(ViewContainerRef);
  #authService = inject(AuthenticationService);
  #injector = inject(Injector); // Szükséges az effect-hez a konstruktoron kívül

  constructor() {
    // Az effect automatikusan lefut, amikor a currentUser signal értéke változik
    effect(() => {
      const user = this.#authService.currentUser(); // Olvasd a signal értékét
      this.#updateView(!!user); // !!user -> boolean konverzió
    }, { injector: this.#injector }); // Add meg az injectort, ha nem a konstruktorban vagy
  }

  #updateView(isLoggedIn: boolean): void {
    this.#viewContainer.clear(); // Először mindig töröljük a régit
    if (isLoggedIn) {
      this.#viewContainer.createEmbeddedView(this.#templateRef);
    }
  }
}
